import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { materialModules } from '@shared/material';
import { SharedModule } from '@shared/shared.module';
import { OscReferenceAppCommonModule } from 'osc-reference-app-common';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { ReportSharedModule } from '../report-shared/report-shared.module';
import { components } from './components';
import { dialogs } from './dialogs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ...materialModules,
    OscReferenceAppCommonModule,
    OscUtilsModule,
    ReactiveFormsModule,
    ReportSharedModule,
    SharedModule,
    ...components,
    ...dialogs,
  ],
  exports: [...components, ...dialogs],
})
export class WebReportModule {}
